import React, { useState } from "react";
import PropTypes from "prop-types";
import Papa from "papaparse"; // 👈 CSV parsing

import Button from "../common/Button";

import "./BpadAddApplicant.scss";
import DeleteIcon from "../../assets/Icons/Trash-prescreen.png";

export default function BpadInvite({ sendData, closeModal }) {
  const [inputs, setInputs] = useState(Array(5).fill({ name: "", email: "", reqId: "", candidateId: "" }));
  const [loading, setLoading] = useState(false);

  const handleInputChange = (i, value, type) => {
    setInputs((prev) =>
      prev.map((inp, index) => {
        if (index === i) {
          return { ...inp, [type]: value };
        }
        return inp;
      })
    );
  };

  const handleAddInput = () => {
    setInputs((prev) => [...prev, { name: "", email: "", reqId: "", candidateId: "" }]);
  };

  const handleDeleteInput = (i) => {
    setInputs((prev) => prev.filter((_, index) => index !== i));
  };

  const handleCSVUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      complete: (result) => {
        const rows = result.data;

        // Normalize rows
        const parsed = rows.map((row) => ({
          name: row.name || row.Name || "",
          email: row.email || row.Email || "",
          reqId: row.reqId || row.ReqId || row.req_id || "",
          candidateId: row.candidateId || row.CandidateId || row.candidate_id || "",
        }));
        console.log("Parsed CSV:", parsed);

        if (parsed.length > 0) {
          setInputs(parsed);
        }
      },
    });
  };

  const onSuccess = () => {
    setLoading(false);
    setInputs(Array(5).fill({ name: "", email: "", reqId: "", candidateId: "" }));
    closeModal();
  };

  const onError = () => {
    setLoading(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    // Only keep entries with name+email filled
    const filteredInputs = inputs.filter(
      (item) => item.name && item.email
    );

    sendData(filteredInputs, onSuccess, onError);
  };

  return (
    <div className="tooltip">
      <h2>Invite Individuals</h2>

      {/* CSV Upload */}
      <input
        type="file"
        accept=".csv"
        onChange={handleCSVUpload}
        style={{ marginBottom: "1rem" }}
      />

      <form className="bpadForm" onSubmit={handleSubmit}>
        <div className="bpadTableGrid">
          <p className="firstColumn bpadTitleBold">Sr. No</p>
          <p className="bpadTitleBold">Name</p>
          <p className="bpadTitleBold">Email ID</p>
          <p className="bpadTitleBold">Req ID</p>
          <p className="bpadTitleBold">Candidate ID</p>
        </div>

        {inputs.map((inp, index) => (
          <div key={index} className="bpadTableGridWrapper">
            <div className="bpadTableGrid">
              <p className="firstColumn">{index + 1}.</p>
              <input
                type="text"
                value={inp.name}
                placeholder="Enter name"
                className="bpadInputs"
                onChange={(e) =>
                  handleInputChange(index, e.target.value, "name")
                }
              />
              <input
                type="email"
                value={inp.email}
                placeholder="Enter email"
                className="bpadInputs"
                onChange={(e) =>
                  handleInputChange(index, e.target.value, "email")
                }
              />
              <input
                type="text"
                value={inp.reqId}
                placeholder="Enter req ID"
                className="bpadInputs"
                onChange={(e) =>
                  handleInputChange(index, e.target.value, "reqId")
                }
              />
              <input
                type="text"
                value={inp.candidateId}
                placeholder="Enter candidate ID"
                className="bpadInputs"
                onChange={(e) =>
                  handleInputChange(index, e.target.value, "candidateId")
                }
              />
            </div>
            <div className="bpadFormActionBtns">
              {index === inputs.length - 1 && (
                <div className="add-question-btn" onClick={handleAddInput} />
              )}
              {inputs.length > 1 && (
                <img
                  src={DeleteIcon}
                  className="delete-question-btn"
                  onClick={() => handleDeleteInput(index)}
                />
              )}
            </div>
          </div>
        ))}

        <div className="bpadFormBtnsBox">
          <Button
            size="small"
            variant="contained"
            style={{
              marginRight: 10,
              fontWeight: "bold",
              letterSpacing: "0.01em",
              borderRadius: "25px",
              padding: "8px 20px",
              fontSize: 14,
              backgroundColor: "#f0f0f0",
              color: "#000",
            }}
            onClick={closeModal}
          >
            Cancel
          </Button>
          <Button
            type={"submit"}
            size="small"
            variant="contained"
            style={{
              fontWeight: "bold",
              letterSpacing: "0.01em",
              borderRadius: "25px",
              padding: "8px 20px",
              fontSize: 14,
            }}
            disabled={loading}
          >
            Submit
          </Button>
        </div>
      </form>
    </div>
  );
}

BpadInvite.propTypes = {
  sendData: PropTypes.func,
  closeModal: PropTypes.func,
};
